<template>
    <div class=" tab-pane form-comment" id="description" role="tabpanel" aria-expanded="false">
        <article>
            <div  class="text-p-description" v-html="description"> </div>
        </article>
    </div>
</template>
 
<script>
    import { httpPromise } from "../../module/httpUtility";
    export default {
        data() {
            return {
                description: '', 
                
            }
        },
        watch: {
            
        },
        beforeMount: function () {
            this.sendToServer();
        },
        props: { 
            isLoadDescription: {
                type: Boolean,
            }
        },
        methods: {
            sendToServer() {
                httpPromise(this, '/v1/ProductManagement/ProductDescriptions/Find', 'get', { ProductId: this.$route.params.productId },
                    response => {
                        this.description = response.data.Value.Description;
                    },
                    response => {

                    }
                );
            }
        }, 
    }
</script>
<style scoped>
    #description p.text-p-description {
        font-size: 13px !important;
    }

    @media only screen and (min-width: 0px) and (max-width: 640px) {
        .text-p-description p {
            font-size: 13px;
            line-height: 1.8;
        }
    }
</style>